<template>
  <div 
  class="row"
    style="
      background: url('/img/bg-1.png') no-repeat left;
      background-size: contain;
      height: 100vh;
      overflow: auto;
    "
  >
    <div class="col-lg-12">
      <div class="full-page">
        <!-- <div class="full-page" :class="pageClass"> -->
        <div class="content">
          <div class="row">
            <div style="margin-top: -70px" class="col-lg-12 text-center">
              <p style="font-size: 29px; color: #358CCB">Sign Up</p>
            </div>
          </div>
          <div class="row">
            <div
              style="margin-top: -30px; margin-bottom: 50px"
              class="col-lg-12 text-center"
            >
              <p style="font-size: 18px; color: #b9b9b9">
                Please fill up the information to register
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6 d-flex">
              <card
                class="card-eprf"
              >
                <p
                  style="
                    color: #358CCB;
                    font-size: 24px;
                    font-weight: 300;
                    padding: 30px 30px 0px 30px;
                  "
                >
                  OPERATION DETAILS 
                </p>

                <div
                  class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
                >
                  <p style="color: #A5A5A5; opacity: 0.7">Facility Type </p>
                  <div>
                    <div
                      style="line-height: 0.7cm"
                      v-for="(file, index) in facilitytypes"
                      :key="index"
                    >
                      <input
                        style="border: 1px solid #5e99ff"
                        type="radio"
                        class="rounded-checkbox"
                        id="checkbox"
                        v-model="checkedItems"
                        :value="facilitytypes[index].value"
                      />&nbsp;&nbsp;{{ facilitytypes[index].label }}
                    </div>
                    <div v-if="checkedItems === 4">
                      <div style="padding-right: 30px; width: 50%">
                        <input
                          type="text"
                          v-model="specify"
                          :class="{ 'custom-input': true }"
                        />
                      </div>
                    </div>
                  </div>

                  <p
                    style="
                      color: #358CCB;
                      font-size: 24px;
                      font-weight: 300;
                      padding: 30px 0px 0px 0px;
                    "
                  >
                    WASTE CODE HANDLED 
                  </p>
                  <div>
                    <div
                      style="
                        display: grid;
                        grid-template-columns: auto 1fr;
                        align-items: center;
                        grid-gap: 10px;
                      "
                      v-for="(file, index) in wastecode"
                      :key="index"
                    >
                      <input
                        type="checkbox"
                        class="rounded-checkbox"
                        id="checkbox"
                        style="
                          align-self: flex-start;
                          margin-top: 0.25em;
                          border: 1px solid #5e99ff;
                        "
                        v-model="checkedItems1"
                        :value="wastecode[index].value"
                      />
                      <label
                        for="checkbox"
                        style="font-size: 14px; color: #A5A5A5; grid-column: 2"
                        >{{ wastecode[index].label }} -
                        {{ wastecode[index].desc }}</label
                      >
                    </div>
                  </div>
                  <!-- <p>{{ checkedItems1 }}</p> -->

                  <!--value of checked, jangan delete-->
                  <!-- <div v-if="checkedItems1.length > 0">
                    <h4>Checked Items:</h4>
                    <ul>
                      <li v-for="(item, i) in checkedItems1" :key="i">
                        {{ item }}
                      </li>
                    </ul>
                  </div> -->
                </div>
              </card>
            </div>
            <div class="col-lg-3 d-flex">
              <card
                class="card-eprf"
              >
                <p
                  style="
                    color: #358CCB;
                    font-size: 24px;
                    font-weight: 300;
                    padding: 30px;
                  "
                >
                  DOE LICENSE
                </p>
                <div
                  class="w-100 p-4 d-flex align-items-center justify-content-center"
                  style="height: 250px"
                >
                  <div
                    class="w-100 p-4 d-flex align-items-center justify-content-center"
                    style="
                      border: 2px dashed #dcdcdc;
                      height: 280px;
                      width: 350px;
                    "
                  >
                    <div class="col-lg-12 text-center">
                      <i
                        style="
                          color: lightgray;
                          font-size: 90px;
                          font-weight: 500;
                          margin-bottom: 10px;
                        "
                        class="tim-icons icon-upload"
                      ></i>

                      <p style="font-weight: 600; color: #787878">
                        Drop files to upload
                      </p>
                      <div class="row">
                        <div class="col-lg"></div>

                        <p style="font-weight: 600; color: #787878">or</p>
                        &nbsp;
                        <div class="fileinput">
                          <label for="file-upload">
                            <p
                              style="
                                font-weight: 600;
                                font-size: 14px;
                                color: #5e99ff;
                                text-decoration: underline;
                                cursor: pointer;
                              "
                            >
                              browse
                            </p>
                          </label>
                          <input
                            accept="application/pdf"
                            id="file-upload"
                            type="file"
                            ref="file"
                            name="..."
                            class="valid"
                            :multiple="true"
                            aria-invalid="false"
                            style="display: none"
                            v-on:change="onFileChange"
                          />
                        </div>

                        <div class="col-lg"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    height: 100px;
                    padding: 20px 20px 0px 20px;
                    margin: 30px 30px 0px 0px;
                  "
                  class="d-flex justify-content-center spinner"
                  v-if="this.uploadload == true"
                >
                  <circle-8></circle-8>
                </div>
                <div
                  v-if="this.uploadload == false"
                  style="
                    height: 100px;
                    padding: 20px 20px 0px 20px;
                    margin: 30px 30px 0px 0px;
                  "
                  class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
                >
                  <div
                    v-for="(file, index) in allfilename"
                    :key="index"
                    class="row"
                  >
                    <div class="col-lg-8">
                      <p
                        style=" color: #aaaaaa"
                        v-if="selectedFileName"
                        id="file-name"
                      >
                        {{ file }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <base-button
                        v-if="selectedFileName"
                        class="btn-sm btn-cancel"
                    style="font-size: 12px; "
                        @click="removeFile(index)"
                      >
                        Remove
                    </base-button>
                    </div>
                  </div>
                  <div
                    v-for="(file, index) in support_doc_list"
                    :key="index"
                    class="row"
                  >
                    <div class="col-lg-8">
                      <p
                        style=" color: #A5A5A5; opacity: 0.7"
                      >
                        {{ file }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <base-button
                      class="btn-sm btn-cancel"
                    style="font-size: 12px; "
                        @click="removeFile2(index)"
                      >
                        Remove
                    </base-button>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <p
                    style="
                      padding-left: 30px;

                      font-size: 15px;
                      color: #A5A5A5;
                      opacity: 0.7;
                    "
                  >
                    DOE License Expiry Date: {{ this.doedate }}
                  </p>
                </div>
                <div style="padding-left: 10px" class="col-lg-7">
                  <el-date-picker
                    v-model="selects.date"
                    @change="getData()"
                  ></el-date-picker>
                </div>
              </card>
            </div>
            <div class="col-lg"></div>
          </div>
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6"></div>
            <div class="col-lg-3 text-right">
              <base-button type="danger" v-on:click="cancelRegister()"
                >Back</base-button
              >&nbsp;
              <base-button type="primary" v-on:click="handleDone()"
                >Next</base-button
              >
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Alert, Select, Option, DatePicker } from "element-ui";
import swal from "sweetalert2";
import Card from "../../../components/Cards/Card.vue";
import { Modal, ImageUpload } from "../../../components";
import moment, { invalid } from "moment";
import { Circle8 } from "vue-loading-spinner";
import { debounce } from "src/util/debounce";

export default {
  name: "VendorRegistration-1",
  components: {
    Card,
    [DatePicker.name]: DatePicker,
    Modal,
    ImageUpload,
    Circle8,
  },

  data() {
    return {
      selectedFileName: "",
      allfilename: [],

      specify: "",

      facilitytypes: [
        { value: 1, label: "Recovery" },
        { value: 2, label: "Disposal" },
        { value: 3, label: "Conveyance" },
        { value: 4, label: "Others (please specify):" },
        { value: 5, label: "Not applicable" },
      ],

      checkedItems: 0,
      checkedItems1: [],
      checkedItems12: "",

      wastecode: [
        {
          value: 1,
          label: "SW101 - Waste containing arsenic or its compound",
        },
        {
          value: 2,
          label:
            "SW102 - Waste of lead acid batteries in whole or crushed form",
        },
        {
          value: 3,
          label:
            "SW103 - Waste of batteries containing cadmium and nickel or mercury or lithium",
        },
        {
          value: 4,
          label:
            "SW104 - Dust, slag, dross or ash containing arsenic, mercury, lead, cadmium, chromium, nickel, copper, vanadium, beryllium, antimony, tellurium, thallium or selenium excluding slag from iron and steel factory.",
        },
        { value: 5, label: "SW105 - Galvanic sludges" },
        {
          value: 6,
          label: "SW106 - Residues from recovery of acid pickling liquor",
        },
        {
          value: 7,
          label:
            "SW107 - Slags from copper processing for further processing or refining containing arsenic, lead or cadmium",
        },
        {
          value: 8,
          label:
            "SW108 - Leaching residues from zinc processing in dust and sludges form",
        },
        {
          value: 9,
          label: "SW109 - Waste containing mercury or its compound",
        },
        {
          value: 10,
          label:
            "SW110 - Waste from electrical and electronic assemblies containing components such as accumulators, mercury-switches, glass from cathode-ray tubes and other activated glass olychlorinated biphenyl-capacitors, or contaminated with cadmium, mercury, lead, nickel, chromium, copper, lithium, silver, manganese or polychlorinated biphenyl",
        },
        {
          value: 11,
          label: "SW201 - Asbestos wastes in sludges, dust or fibre forms",
        },
        { value: 12, label: "SW202 - Waste catalysts" },
        {
          value: 13,
          label:
            "SW203 - Immobilized scheduled wastes including chemically fixed, encapsulated, solidified or stabilized sludges",
        },
        {
          value: 14,
          label:
            "SW204 - Sludges containing one or several metals including chromium, copper, nickel, zinc, lead, cadmium, aluminium, tin, vanadium and beryllium",
        },
        {
          value: 15,
          label:
            "SW205 - Waste gypsum arising from chemical industry or power plant",
        },
        { value: 16, label: "SW206 - Spent inorganic acids" },
        { value: 17, label: "SW207 - Sludges containing fluoride" },
      ],

      //data from user
      companyname: "",
      doeno: "",
      companyaddress: "",
      phoneno: "",
      faxno: "",
      supportdoc: "",

      fullname: "",
      password: "",
      confirmpassword: "",
      phoneno1: "",
      faxno1: "",
      email: "",

      fullname2: "",
      password2: "",
      confirmpassword2: "",
      phoneno2: "",
      faxno2: "",
      email2: "",

      modals: {
        modal2: false,
      },

      pic: [],

      selects: {
        date: "",
      },

      selecteddate: "",
      doedate: "",

      docs: "",
      document: 0,

      documentID: [],

      uploadload: false,

      support_doc: "",
      support_doc_list: [],
    };
  },
  methods: {
    getData() {
      this.selecteddate = this.selects.date;
      this.doedate = this.selecteddate.toLocaleDateString();
    },
    addCertificate() {
      this.modals.modal2 = true;
    },
    cancelRegister() {
      sessionStorage.setItem("vendor-facility-index", this.checkedItems);
      sessionStorage.setItem("vendor-waste-index", this.checkedItems1);

      sessionStorage.setItem("vendor-facility-type-specify", this.specify);
      sessionStorage.setItem("vendor-date-expired", this.doedate);

      this.$router.push("/vendor-register");
    },
    handleDone() {
      sessionStorage.setItem("vendor-facility-index", this.checkedItems);
      sessionStorage.setItem("vendor-facility-type-specify", this.specify);
      sessionStorage.setItem("vendor-date-expired", this.doedate);

      sessionStorage.setItem("vendor-waste-index", this.checkedItems1);
      if (this.checkedItems != 4) {
        sessionStorage.setItem(
          "vendor-checked-item",
          parseInt(this.checkedItems)
        );
      } else {
        let obj = {
          facility_type_id: 4,
          facility_type_name: this.specify,
        };

        this.$http.post(":10001/api/v1/setting/facilities", obj).then((res) => {
          if (!res.error) {
            let response = res.message;

            sessionStorage.setItem(
              "vendor-checked-item",
              parseInt(response.facility_type_id)
            );

            console.log("jadi");
          } else {
            console.log("xjadi");
          }
        });
      }

      sessionStorage.setItem("vendor-doe-document", this.documentID);
      this.$router.push("/vendor-register-2");
    },
    handleSpecify() {
      let obj = {
        facility_type_id: 4,
        facility_type_name: this.specify,
      };

      this.$http.post(":10001/api/v1/setting/facilities", obj).then((res) => {
        if (!res.error) {
          let response = res.message;

          sessionStorage.setItem(
            "vendor-checked-item",
            parseInt(response.facility_type_id)
          );

          console.log("jadi");
        } else {
          console.log("xjadi");
        }
      });
    },
    onFileChange(event) {
      const t = event.target;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          this.selectedFileName = t.files[i].name;
          this.allfilename.push(this.selectedFileName);
        }
        sessionStorage.setItem("vendor-support-doc-1", this.allfilename);
      } else {
        this.selectedFileName = "";
      }

      this.document = t.files.length;

      var input;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.file.files[i];
          const formData = new FormData();
          formData.append("document", input);
          this.docs = formData;

          this.uploadload = true;
          this.buttondisabled = true;

          this.$http
            .post(":10001/api/v1/upload/doe_support_document", this.docs, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                console.log("data masuk", response);
                this.documentID.push(response.document_id);
              } else {
                console.log("data tak masuk");
              }
            });
          this.uploadload = false;
          this.buttondisabled = false;
        }
      }
    },
    removeFile(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
        this.allfilename.splice(indexToRemove, 1);
        this.documentID.splice(indexToRemove, 1);
      }
      this.$emit("change", null);
    },
    removeFile2(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.support_doc_list.length) {
        this.documentID.splice(indexToRemove, 1);
        this.support_doc_list.splice(indexToRemove, 1);
      }
      sessionStorage.setItem("vendor-support-doc-1", this.support_doc_list);
      // this.$emit("change", null);
    },
    getList() {
      this.wastecode = [];
      this.$http.get(":10001/api/v1/setting/wastes").then((res) => {
        if (!res.error) {
          let response = res.message;

          console.log("heree", response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].code,
              desc: response[i].description,
              value: response[i].waste_type_id,
            };

            this.wastecode.push(obj);
          }

          // this.selects.wastetype = this.selects.wastetypes[0].value;
        }
      });
    },
  },
  watch: {
    checkedItems(newVal) {
      if (newVal === 4) {
        this.handleSpecify();
      }
    },
  },
  created() {},
  mounted() {
    this.getList();
    this.specify =
      sessionStorage.getItem("vendor-facility-type-specify") !== null &&
      sessionStorage.getItem("vendor-facility-type-specify") !== "null"
        ? sessionStorage.getItem("vendor-facility-type-specify")
        : "";

    this.checkedItems =
      sessionStorage.getItem("vendor-facility-index") !== null &&
      sessionStorage.getItem("vendor-facility-index") !== "null"
        ? sessionStorage.getItem("vendor-facility-index")
        : "0";

    this.checkedItems = parseInt(this.checkedItems);

    this.doedate =
      sessionStorage.getItem("vendor-date-expired") !== null &&
      sessionStorage.getItem("vendor-date-expired") !== "null"
        ? sessionStorage.getItem("vendor-date-expired")
        : "";

    // this.support_doc =
    //   sessionStorage.getItem("vendor-support-doc-1") !== null &&
    //   sessionStorage.getItem("vendor-support-doc-1") !== "null"
    //     ? sessionStorage.getItem("vendor-support-doc-1")
    //     : "";

    // this.support_doc = sessionStorage.getItem("vendor-support-doc-1");
    // this.allfilename = this.support_doc.split(",").map(String);
    // this.support_doc_list = this.allfilename;

    this.support_doc = sessionStorage.getItem("vendor-support-doc-1");

    if (this.support_doc) {
      this.support_doc_list = this.support_doc.trim().split(",").map(String);
    } else {
      this.support_doc_list = [];
    }

    const check =
      sessionStorage.getItem("vendor-waste-index") !== null &&
      sessionStorage.getItem("vendor-waste-index") !== "null"
        ? sessionStorage.getItem("vendor-waste-index")
        : "0";
    this.checkedItems12 = check.split(",").map(Number);
    this.checkedItems1 = this.checkedItems12;
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.scrollable {
  height: 520px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}
.rounded-checkbox {
  width: 1.3em;
  height: 1.3em;
  border-radius: 50%;
  vertical-align: middle;
  border: 1px solid #358CCB;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
}
.rounded-checkbox:checked {
  appearance: auto;
  clip-path: circle(50% at 50% 50%);
  background-color: #00f2c3;
}

.remove {
  padding-left: 30px;
  font-size: 12px;
  color: #aaaaaa;
  opacity: 0.5;
}

.remove:hover {
  color: #ff0000;
  cursor: pointer;
}
</style>
